(function () {
  function init(root) {
    var knoppen = root.querySelectorAll('[data-wsl-knop]');
    var doelen = root.querySelectorAll('[data-wsl-doel]');
    var groep = root.querySelector('[data-wsl-knoppen]');
    var gekozen = null;
    var klaar = false;
    knoppen.forEach(function (k) { if (k.classList.contains('is-actief')) gekozen = k.getAttribute('data-key'); });
    function toon(key) {
      if (klaar) root.classList.add('is-gewisseld');
      knoppen.forEach(function (k) {
        var aan = k.getAttribute('data-key') === key;
        k.classList.toggle('is-actief', aan);
        k.setAttribute('aria-pressed', aan ? 'true' : 'false');
      });
      doelen.forEach(function (d) { d.classList.toggle('is-actief', d.getAttribute('data-key') === key); });
    }
    knoppen.forEach(function (k) {
      k.addEventListener('click', function () { gekozen = k.getAttribute('data-key'); toon(gekozen); });
    });
    if (root.getAttribute('data-wsl-hover') === 'true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      knoppen.forEach(function (k) {
        var h = function () { toon(k.getAttribute('data-key')); };
        k.addEventListener('mouseenter', h);
        k.addEventListener('focus', h);
      });
      if (groep) groep.addEventListener('mouseleave', function () { toon(gekozen); });
    }
    klaar = true;
  }
  document.querySelectorAll('[data-wsl-keuze]').forEach(init);
})();
